(function (win) {
  'use strict';
  if (win.SickstyleGoogleDesign) return;
  const measurementId = 'G-H14GDGCZM2';
  const themeId = '204708315400';
  const names = Object.freeze({
    'ss_mx:landing_view': 'ss_mx_landing_view',
    'ss_mx:product_view': 'ss_mx_product_view',
    'ss_mx:design_select': 'ss_mx_design_select',
    'ss_mx:inquiry_open': 'ss_mx_inquiry_open',
    'ss_mx:native_add_confirmed': 'ss_mx_native_add_confirmed'
  });
  const ids = value => typeof value === 'string' && /^[1-9][0-9]{0,19}$/.test(value);
  const categories = new Set(['mx', 'street', 'emoto']);
  const locales = new Set(['de', 'en', 'fr', 'it', 'es', 'nl', 'pl', 'cs', 'sv', 'da']);
  const positions = new Set(['hero', 'grid', 'product', 'sticky', 'footer']);
  const delivered = new WeakSet();
  let ready = false;
  let pending = false;
  let generation = 0;
  let checkedFunction;
  let status = 'not_checked';
  let panel;
  let statusNode;
  let probeButton;
  let testButton;
  let testSent = false;
  let retryTimer;
  let retryBudget = 0;
  const allowed = () => {
    try { return win.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  };
  function safePage() {
    const origin = win.location?.origin;
    const pathname = win.location?.pathname;
    if (origin !== 'https://www.sickstylegraphics.de' && origin !== 'https://sickstylegraphics.de') return null;
    if (typeof pathname !== 'string' || !/^\/(?:de\/|en\/|fr\/|it\/|es\/|nl\/|pl\/|cs\/|sv\/|da\/)?(?:pages|products)\/[a-z0-9_-]+\/?$/i.test(pathname)) return null;
    return origin + pathname;
  }
  function ownTheme() {
    return String(win.Shopify?.theme?.id) === themeId && win.Shopify?.designMode !== true;
  }
  function production() {
    return ownTheme() && win.Shopify?.theme?.role === 'main' && win.Shopify?.previewMode !== true && !/[?&]preview_theme_id=/.test(win.location?.search || '');
  }
  function diagnostic() {
    if (!ownTheme() || win.Shopify?.theme?.role !== 'unpublished' || !safePage()) return false;
    const flags = new URLSearchParams(win.location?.search || '').getAll('ss_measurement_test');
    return flags.length === 1 && flags[0] === '1';
  }
  function isReady() {
    if (!allowed() || typeof win.gtag !== 'function' || win.gtag !== checkedFunction) ready = false;
    return ready;
  }
  const messages = Object.freeze({
    not_checked: 'Verbindung noch nicht geprüft.',
    blocked_consent: 'Bitte zuerst die Analytics-Einwilligung über die Cookie-Einstellungen erteilen. Es wurde nichts gesendet.',
    unavailable: 'Der vorhandene Google-Tag ist in diesem Browser noch nicht verfügbar.',
    checking: 'Der vorhandene Google-Tag wird geprüft …',
    ready: 'Google-Tag antwortet. Der Verbindungstest kann jetzt gesendet werden. Das bestätigt noch keinen Eingang in GA4.',
    no_response: 'Der Google-Tag hat nicht rechtzeitig geantwortet. Du kannst die Verbindung erneut prüfen.',
    failed: 'Die Verbindung konnte nicht geprüft werden.',
    test_called: 'Ein einzelner Debug-Verbindungstest wurde an den vorhandenen Google-Tag übergeben. Den Eingang jetzt in GA4 DebugView prüfen.'
  });
  function refreshPanel() {
    if (!panel) return;
    statusNode.textContent = messages[status] || messages.not_checked;
    probeButton.disabled = pending;
    testButton.disabled = pending || !isReady() || testSent;
  }
  function changeStatus(next) { status = next; refreshPanel(); }
  function check() {
    if ((!production() && !diagnostic()) || !safePage()) return false;
    if (!allowed()) { ready = false; changeStatus('blocked_consent'); return false; }
    if (isReady()) { changeStatus(testSent ? 'test_called' : 'ready'); return true; }
    if (pending) return false;
    if (typeof win.gtag !== 'function') { changeStatus('unavailable'); return false; }
    checkedFunction = win.gtag;
    const current = ++generation;
    pending = true;
    changeStatus('checking');
    const timer = win.setTimeout(() => {
      if (current !== generation || !pending) return;
      pending = false;
      ready = false;
      changeStatus('no_response');
    }, 3000);
    try {
      checkedFunction('get', measurementId, 'client_id', value => {
        if (current !== generation || !pending) return;
        win.clearTimeout(timer);
        pending = false;
        ready = allowed() && win.gtag === checkedFunction && typeof value === 'string' && value.length > 0;
        changeStatus(ready ? 'ready' : allowed() ? 'no_response' : 'blocked_consent');
        if (ready) {
          stopRetries();
          if (win.document) win.document.dispatchEvent(new win.CustomEvent('ss-mx-receiver-ready'));
        }
      });
    } catch (_) {
      win.clearTimeout(timer);
      pending = false;
      ready = false;
      changeStatus('failed');
    }
    return isReady();
  }
  function stopRetries() {
    if (retryTimer !== undefined) win.clearTimeout(retryTimer);
    retryTimer = undefined;
    retryBudget = 0;
  }
  function startReadinessChecks() {
    stopRetries();
    if (!production() || !allowed()) return;
    retryBudget = 10;
    const attempt = () => {
      retryTimer = undefined;
      if (!production() || !allowed() || isReady() || retryBudget <= 0) { stopRetries(); return; }
      retryBudget--;
      check();
      if (!isReady() && retryBudget > 0) retryTimer = win.setTimeout(attempt, 1000);
    };
    attempt();
  }
  function parameters(data) {
    if (!data || data.schema_version !== 1 || data.flow_version !== 'mx-native-v1' || data.theme_id !== themeId || !categories.has(data.category) || !locales.has(data.locale)) return null;
    const location = safePage();
    if (!location) return null;
    const params = {
      send_to: measurementId, schema_version: 1, flow_version: 'mx-native-v1',
      category: data.category, locale: data.locale, theme_id: themeId, environment: 'production',
      page_location: location, page_referrer: '', page_title: 'Sickstyle design selection'
    };
    for (const key of ['page_id', 'model_page_id', 'product_id', 'variant_id']) {
      if (data[key] !== undefined && !ids(data[key])) return null;
      if (ids(data[key])) params[key] = data[key];
    }
    if (data.cta_position !== undefined) {
      if (!positions.has(data.cta_position)) return null;
      params.cta_position = data.cta_position;
    }
    return params;
  }
  function send(name, data) {
    if (!Object.prototype.hasOwnProperty.call(names, name) || !data || typeof data !== 'object' || delivered.has(data)) return false;
    if (!production() || data.environment !== 'production' || !allowed()) return false;
    if (!isReady()) { startReadinessChecks(); return false; }
    const params = parameters(data);
    if (!params) return false;
    if (name === 'ss_mx:landing_view' && !params.page_id) return false;
    if (name === 'ss_mx:product_view' && !params.product_id) return false;
    if (name === 'ss_mx:design_select' && (!params.product_id || !params.variant_id || !params.cta_position)) return false;
    if (name === 'ss_mx:inquiry_open' && !params.cta_position) return false;
    if (name === 'ss_mx:native_add_confirmed') {
      if (!Array.isArray(data.items) || data.items.length < 1 || data.items.length > 100) return false;
      if (!data.items.every(item => item && ids(item.product_id) && ids(item.variant_id) && Number.isInteger(item.line_quantity_after) && item.line_quantity_after > 0 && item.line_quantity_after <= 10000)) return false;
      params.line_count = data.items.length;
      params.items = data.items.map(item => ({item_id: item.variant_id, product_id: item.product_id, line_quantity_after: item.line_quantity_after}));
    }
    delivered.add(data);
    try { win.gtag('event', names[name], params); return true; }
    catch (_) { return false; }
  }
  function sendConnectionTest(event) {
    if (event?.isTrusted !== true || testSent || !diagnostic() || !allowed() || !isReady()) return false;
    const location = safePage();
    if (!location) return false;
    testSent = true;
    try {
      win.gtag('event', 'ss_mx_connection_test', {
        send_to: measurementId, debug_mode: true, environment: 'qa_connection',
        schema_version: 1, theme_id: themeId, test_version: 'design-connection-v1', test_run: 'design_20261103',
        page_location: location, page_referrer: '', page_title: 'Sickstyle measurement connection test'
      });
      changeStatus('test_called');
      return true;
    } catch (_) { changeStatus('failed'); return false; }
  }
  function mountPanel() {
    if (!diagnostic() || !win.document?.querySelector('[data-ss-measure-config]') || panel) return;
    panel = win.document.createElement('aside');
    panel.setAttribute('data-ss-measure-diagnostic', '');
    panel.setAttribute('aria-label', 'Google-Messung prüfen');
    panel.style.cssText = 'position:fixed;left:12px;bottom:70px;z-index:2147483000;max-width:440px;padding:16px;border:2px solid #203b2c;border-radius:12px;background:#fff;color:#14221a;box-shadow:0 4px 28px #0003;font:15px/1.45 system-ui,sans-serif;';
    const title = win.document.createElement('strong');
    title.textContent = 'Google-Messung · Entwurfstest';
    const info = win.document.createElement('p');
    info.textContent = 'Dieser Test sendet nach Analytics-Einwilligung genau ein gekennzeichnetes Debug-Ereignis. Designaktionen dieser Vorschau bleiben lokal. Es wird kein Kauf gemeldet.';
    statusNode = win.document.createElement('p');
    statusNode.setAttribute('role', 'status');
    probeButton = win.document.createElement('button');
    probeButton.type = 'button';
    probeButton.textContent = 'Google-Verbindung prüfen';
    testButton = win.document.createElement('button');
    testButton.type = 'button';
    testButton.textContent = 'Einmaligen Verbindungstest senden';
    for (const button of [probeButton, testButton]) button.style.cssText = 'display:block;margin-top:8px;padding:8px 12px;border:1px solid #345840;border-radius:6px;background:#e8f1e8;color:#14221a;font:inherit;cursor:pointer;';
    probeButton.addEventListener('click', event => { if (event.isTrusted) check(); });
    testButton.addEventListener('click', sendConnectionTest);
    panel.appendChild(title); panel.appendChild(info); panel.appendChild(statusNode); panel.appendChild(probeButton); panel.appendChild(testButton);
    win.document.body.appendChild(panel);
    refreshPanel();
  }
  win.SickstyleGoogleDesign = Object.freeze({version: 1, ready: isReady, check, send});
  if (win.document) {
    const initialize = () => { mountPanel(); if (production()) startReadinessChecks(); };
    if (win.document.readyState === 'loading') win.document.addEventListener('DOMContentLoaded', initialize, {once: true});
    else initialize();
    win.document.addEventListener('visitorConsentCollected', () => {
      if (!allowed()) { stopRetries(); ready = false; pending = false; generation++; changeStatus('blocked_consent'); }
      else if (production()) startReadinessChecks();
      else refreshPanel();
    });
  }
})(window);
